import { inject, Injectable } from '@angular/core'
import { UsersService } from './users.service'
import { LoggerService } from './logger.service'
import { environment } from '../environments/environment'
import { constructNameForUser } from './utils'
import Intercom from '@intercom/messenger-js-sdk'
import { queryKeys } from './query-keys'
import { HttpClient } from '@angular/common/http'
import { injectMutation, injectQuery } from '@ngneat/query'

@Injectable({
  providedIn: 'root',
})
export class IntercomService {
  usersService = inject(UsersService)
  loggerService = inject(LoggerService)
  httpClient = inject(HttpClient)
  query = injectQuery()
  mutation = injectMutation()

  initialize() {
    const user = this.usersService.currentUser$.value
    if (user !== null && user.organization.isIntercomEnabled && user.intercomHash !== null && user.intercomAppId !== null && environment.production) {
      Intercom({
        region: 'eu',
        app_id: user.intercomAppId,
        user_id: `${user.environment}-${user.id}`,
        name: constructNameForUser(user),
        email: user.email,
        company: user.organization.name,
      })
      this.loggerService.info('Intercom initialized.')
    }
  }

  getAdmins() {
    return this.query({
      queryKey: queryKeys.intercom.admins,
      queryFn: () => this.httpClient.get<any[]>('/api/intercom/admins'),
    }).result$
  }

  startConversationMutation() {
    return this.mutation({
      mutationFn: (data: { adminId: string; message: string; userId: number }) => this.httpClient.post<void>(`api/intercom/start-conversation`, data),
    })
  }
}
